export default __webpack_public_path__ + "static/PURPLE_GLOW_BG-6321ca75e64062b132e3f84e7fc09edd.png";